import { ShieldCheck, ChartLineUp, Eye } from "@phosphor-icons/react";
import { Chapter, Reveal } from "./Reveal";
import { useLiveRate, rateRangeText } from "@/lib/useLiveRate";

export default function CleanFunds() {
  const liveRate = useLiveRate();
  const CARDS = [
    {
      icon: ShieldCheck,
      title: "Verified Process",
      text: "Transactions go through the required verification checks before any processing begins.",
    },
    {
      icon: ChartLineUp,
      title: "Competitive Rates",
      text: `Indicative rates can reach ${rateRangeText(liveRate)} / USDT, depending on market conditions, volume and transaction details.`,
    },
    {
      icon: Eye,
      title: "Transparent Handling",
      text: "Clear transaction details and status at every stage of the process.",
    },
  ];

  return (
    <section id="about" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-testid="clean-funds-section">
      <Chapter index="01" label="Clean Funds" />
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <Reveal delay={0.1}>
          <h2 className="max-w-xl font-display text-4xl font-semibold tracking-tighter text-paper sm:text-5xl">
            Clean Funds. <span className="text-brand-400">Clear Process.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="max-w-md text-base leading-relaxed text-mist">
            Rupora focuses on clean and traceable fund exchange with a transparent process.
            Every transaction follows the required verification and compliance checks before
            processing.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={0.08 + i * 0.08} className="h-full">
            <div
              className="group h-full rounded-3xl border border-line bg-pine p-8 transition-all duration-500 hover:-translate-y-1 hover:border-brand-500/40 hover:shadow-xl hover:shadow-brand-500/10"
              data-testid={`clean-card-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-500/12 text-brand-400 transition-colors duration-500 group-hover:bg-brand-500 group-hover:text-white">
                <c.icon size={24} weight="duotone" />
              </div>
              <h3 className="font-display text-lg font-semibold tracking-tight text-paper sm:text-xl">{c.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-mist">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
